//[AI-GEN] 资源中心路由模块
import Layout from '@/layout/Main.vue'
export default [
  {
    path: '/resource',
    name: 'resource',
    component: Layout,
    sign: 'resource_center',
    redirect: '/resource/article',
    meta: {
      title: '资源中心',
    },
    children: [
      {
        path: 'article',
        name: 'resourceArticle',
        sign: 'resource_article_management',
        component: () => import('@/views/resource/article/index.vue'),
        meta: {
          title: '文章管理',
        },
      },
      {
        path: 'article/detail/:id',
        name: 'resourceArticleDetail',
        component: () => import('@/views/resource/article/detail.vue'),
        meta: {
          title: '查看详情',
          hidden: true,
        },
      },
    ],
  },
]
